import { useState, useEffect } from "react";

import { isNotNullOrEmpty } from "../lib/utilities";
import { filterByItemKey } from "../lib/filters";
import BookList from "./bookList";
import * as api from "../lib/api";

const BooksBySeries = ({ seriesId, items }) => {
  const [series, setSeries] = useState([]);

  useEffect(() => {
    const results = api.getSeriesById(seriesId);

    if (isNotNullOrEmpty(results)) {
      let bookSeries = results[0];

      //get all books in series, add to book obj
      const seriesBooks = filterByItemKey("series", seriesId, items);
      const sortedBooks = api.sortBySeriesOrder(seriesBooks);
      bookSeries.items = [...sortedBooks];

      setSeries(bookSeries);
    }
  }, [seriesId, items]);

  if (!series) return null;

  return (
    <div className="section">
      <div className="subheading" id={seriesId}>
        <h5>
          <a href={`/series/${series.route}`}>{series.title}</a>
        </h5>
      </div>
      <div className="content">
        <BookList items={series.items ?? []} />
      </div>
    </div>
  );
};

export default BooksBySeries;
